/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import HoverSplash from './hoverSplash';
import { getEmbedUrlYoutube } from '/client/src/utils/youTubeEmbedUrl';
import { getEmbedUrlVimeo, viRegExp } from '/client/src/utils/vimeoEmbedUrl';

type PropsType = {
  p: {
    videos?: [],
    background_color?: string,
    link_label: string,
    id: number
  }
};

const Video = (props: PropsType): React.Element<'div'> => {
  const { p } = props;

  return (
    <div
      className={`splash-section splash-section-sounds ${p.background_color === 'Light' ? 'splash_section_light' : 'splash_section_dark'}`}
      id={`${_.toLower(p.link_label)}${p.id}`}
    >
      <div className="splash-container">
        {
          <>
            {_.map(
              _.sortBy(p.videos, (_p: {}): number => _p.placement_index),
              (vf: {}, vfi: number): React.Elemnt<'div'> => {
              return (
                <div className="splash-iframe embed-responsive embed-responsive-16by9" key={`p.audio-${vfi}`}>
                  <iframe
                    frameBorder="0"
                    allowtransparency="true"
                    allowFullScreen
                    src={vf.url.match(viRegExp) ? getEmbedUrlVimeo(vf.url) : getEmbedUrlYoutube(vf.url)}
                  />
                </div>
              );
            })}
          </>
        }
      </div>
      <HoverSplash {...props} />
    </div>
  );
};

export default Video;
